import { action, computed, makeObservable, observable } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import { FormControl } from 'shared/libs/form';

import { JobFormManager } from '../job-form.manager';
import { JobLangGroupItemModel } from './job-lang-group-item';

type LangGroupControl = {
   id: string;
   langControl: FormControl;
   langSkillControl: FormControl;
};

export class JobLangGroupModel {
   readonly lngGroupItem1: JobLangGroupItemModel;
   readonly lngGroupItem2: JobLangGroupItemModel;

   constructor(public readonly jobManager: JobFormManager) {
      makeObservable(this, {
         onAddControl: action.bound,
         onRemoveControl: action.bound,
         langOptions: computed,
         langSkillsOptions: computed,
      });

      this.lngGroupItem1 = new JobLangGroupItemModel(
         this.jobManager.form.controls['lng_1'],
         this.jobManager.form.controls['lng_skill_1']
      );

      this.lngGroupItem2 = new JobLangGroupItemModel(
         this.jobManager.form.controls['lng_2'],
         this.jobManager.form.controls['lng_skill_2']
      );
     
      this.lngGroupItem2.hide();
      
   }

   get langOptions() {
      const attr = this.jobManager.jobAttributes.get();
      if (attr) {
         return attr.langs;
      }
      return [];
   }

   get langSkillsOptions() {
      const attr = this.jobManager.jobAttributes.get();
      if (attr) {
         return attr.lang_skills;
      }
      return [];
   }

   onAddControl(): void {
      // if (this.langGroupControls.length < 2) {
      //    this.langGroupControls.push({
      //       id: uuidv4(),
      //       langControl: this.jobManager.form.controls['lng_2'],
      //       langSkillControl: this.jobManager.form.controls['lng_skill_2'],
      //    });
      //}
   }

   onRemoveControl(id: string): void {
      // const control = this.langGroupControls.find((ctrl) => ctrl.id === id);
      // if (control) {
      //    control.langSkillControl.setValue('');
      //    control.langControl.setValue('');
      //    this.langGroupControls.remove(control);
      // }
   }
}
